enum MatchStatus {
    notStarted,
    team1Wins,
    team2Wins,
    draw,
    byeWin
}

export default MatchStatus;